<template>
  <div class="StockSectionCarousel">
    <div class="opportunities">
      <div class="desktop-view">
        <el-carousel :interval="5000" arrow="never" type="card" height="310px" @change="updateActiveIndex">
          <el-carousel-item v-for="(item, index) in opportunities" :key="index">
            <div class="opportunity-card">
              <!-- Dynamic Image: Changes based on active status -->
              <!-- <div class="live-tag" v-if="isActive(index)">
                <img src="../assets/images/LitePlanExpertView/liveTag.gif" alt="Live" />
              </div> -->
              <div class="card-content">
                <img :src="serverHostName + item.logo" alt="" />
                <h3>{{ item.count ? item.count : '' }}+</h3>
                <h4>{{ item.title ? item.title : '' }}</h4>
                <p>{{ item.contain ? item.contain : '' }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="mobile-view">
        <el-carousel :interval="5000" arrow="never" height="310px" @change="updateActiveIndex" indicator-position="outside">
          <el-carousel-item v-for="(item, index) in opportunities" :key="index">
            <div class="opportunity-card">
              <!-- Dynamic Image: Changes based on active status -->
              <!-- <div class="live-tag" v-if="isActive(index)">
                <img src="../assets/images/LitePlanExpertView/liveTag.gif" alt="Live" />
              </div> -->
              <div class="card-content">
                <img :src="serverHostName + item.logo" alt="" />
                <h3>{{ item.count ? item.count : '' }}+</h3>
                <h4>{{ item.title ? item.title : '' }}</h4>
                <p>{{ item.contain ? item.contain : '' }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { serverAddr, serverHostName } from '../networkConfig';
export default {
  name: 'StockSectionCarousel',
  data() {
    return {
      serverHostName: serverHostName,
      activeIndex: null, // Stores the active carousel index
      opportunities: [],
      // opportunities: [
      //   { title: '982+', sub_title: 'Under ₹500', description: 'Trusted Recommendations at a budget price.', picture: require('@/assets/images/LitePlanExpertView/Under500InactiveIcon.svg') },
      //   { title: '368+', sub_title: 'MTF Approved', description: 'Margin Trading Facility Recommendations From Trusted SEBI Experts.', picture: require('@/assets/images/LitePlanExpertView/MTFActiveIcon.svg') },
      //   { title: '1,568+', sub_title: 'Small Cap', description: 'High-Growth Small Cap Picks By SEBI Experts.', picture: require('@/assets/images/LitePlanExpertView/SmallcapActiveIcon.svg') },
      //   { title: '1,568+', sub_title: 'Small Cap', description: 'High-Growth Small Cap Picks By SEBI Experts.', picture: require('@/assets/images/LitePlanExpertView/SmallcapActiveIcon.svg') },
      // ],
      dataLoading: false,
    };
  },
  mounted() {
    this.getRecoCount();
  },
  methods: {
    isActive(index) {
      return index === this.activeIndex;
    },
    updateActiveIndex(event) {
      this.activeIndex = event;
    },

    getRecoCount() {
      //  'https://uat-api.stockants.com/api/recommendation/v1/equity_recommendation_count'

      this.dataLoading = true; //displayed loader

      serverAddr
        .get('/recommendation/v1/equity_recommendation_count')
        .then((response) => {
          if (response.data.status) {
            this.opportunities = response.data.data;
          }

          this.dataLoading = false; //hide loader
        })
        .catch((error) => {
          console.log(error);
          this.dataLoading = false; //hide loader
        });
    },
  },
};
</script>
  
  <style scoped lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.StockSectionCarousel {
  display: flex;
  justify-content: center;
  align-items: center;

  .opportunities {
    text-align: center;
    padding: 20px;
    width: 1050px;
    margin-top: 40px;

    .live-tag {
      width: 100%;
      text-align: right;

      img {
        width: 45px !important;
        margin: 0 !important;
      }
    }

    .mobile-view {
      display: none;
    }

    .el-carousel {
      width: 100%;
    }

    .el-carousel__item {
      display: flex;
      justify-content: center;
    }

    .el-carousel__item.is-active {
      transform: scale(1.1);
      opacity: 1;
    }

    .el-carousel__item.is-active .opportunity-card {
      box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
      background: linear-gradient(0deg, rgba(45, 46, 141, 1) 0%, rgba(0, 0, 0, 1) 100%);
      color: #fff;
    }

    .opportunity-card {
      padding: 20px;
      border-radius: 10px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      width: 300px;
      text-align: left;
      background: #fff;
      transition: all 0.3s ease;

      .card-content {
        padding: 0px 25px;
      }

      img {
        width: 100px;
        margin-bottom: 20px;
      }

      h3 {
        font-size: 40px;
        margin: 0;
      }
      h4 {
        font-size: 27px;
        margin: 0;
      }

      p {
        font-size: 12px;
        font-weight: 500;
      }
    }
  }

  @media screen and (max-width: 640px) {
    .opportunities {
      .opportunity-card {
        h3 {
          font-size: 27px;
        }
        h4 {
          font-size: 20px;
        }

        .card-content {
          padding: 0px 15px;
        }
      }
      .mobile-view {
        display: block;
      }
      .desktop-view {
        display: none;
      }
    }
  }
}
</style>
<!-- <style lang="scss">
.StockSectionCarousel {
  @media screen and (max-width: 910px) {
    .opportunities .el-carousel {
      width: 800px;
      overflow-x: hidden;
    }
  }
}
</style> -->
  